import React from 'react';

const CorrectAnswerModal = ({
  showPromptModal,
  questionType,
  correctAnswer,
  setCorrectAnswer,
  submitCorrectAnswer,
  optionCount
}) => {
  if (!showPromptModal) return null;

  // helper to turn 0→A, 1→B, etc.
  const letter = i => String.fromCharCode(65 + i);

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div
        className="rounded-lg shadow-lg z-10 max-w-md w-full p-6"
        style={{ backgroundColor: 'var(--card-bg)' }}
      >
        <h2
          className="text-xl font-bold mb-4"
          style={{ color: 'var(--text-color)' }}
        >
          Enter Correct Answer
        </h2>
        <form onSubmit={submitCorrectAnswer}>
          {/* MULTIPLE CHOICE (single‐ or multi‐answer) */}
          {(questionType === 'multiple_choice' ||
            questionType === 'multiple_multiple_choice') && (
              <div className="mb-4">
                <label
                  className="block text-sm font-medium mb-2"
                  style={{ color: 'var(--text-color)' }}
                >
                  Select Correct Option
                </label>
                <div className="flex flex-wrap gap-2">
                  {Array.from({ length: optionCount }, (_, i) => {
                    const opt = letter(i);
                    const isSelected = correctAnswer.includes(opt);
                    return (
                      <button
                        key={opt}
                        type="button"
                        className="px-3 py-2 rounded border transition-colors duration-200"
                        style={{
                          backgroundColor: isSelected
                            ? 'var(--primary-color)'
                            : 'var(--alt-bg)',
                          color: isSelected
                            ? 'var(--nav-active-text)'
                            : 'var(--text-color)',
                          borderColor: 'var(--muted-color)',
                        }}
                        onClick={() => {
                          if (correctAnswer.includes(opt)) {
                            setCorrectAnswer(
                              correctAnswer.filter(a => a !== opt)
                            );
                          } else {
                            setCorrectAnswer([...correctAnswer, opt]);
                          }
                        }}
                      >
                        {opt}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

          {/* YES/NO */}
          {questionType === 'yes_no' && (
            <div className="mb-4">
              <label
                className="block text-sm font-medium mb-2"
                style={{ color: 'var(--text-color)' }}
              >
                Select Correct Option
              </label>
              <div className="flex space-x-2">
                {['Yes', 'No'].map(option => {
                  const isSelected = correctAnswer.includes(option);
                  return (
                    <button
                      key={option}
                      type="button"
                      className="px-3 py-2 rounded border transition-colors duration-200"
                      style={{
                        backgroundColor: isSelected
                          ? 'var(--primary-color)'
                          : 'var(--alt-bg)',
                        color: isSelected
                          ? 'var(--nav-active-text)'
                          : 'var(--text-color)',
                        borderColor: 'var(--muted-color)',
                      }}
                      onClick={() => {
                        if (isSelected) setCorrectAnswer([]);
                        else setCorrectAnswer([option]);
                      }}
                    >
                      {option}
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* SHORT INPUT */}
          {questionType === 'short_input' && (
            <div className="mb-4">
              <label
                className="block text-sm font-medium mb-2"
                style={{ color: 'var(--text-color)' }}
              >
                Enter Correct Answer (Max 20 characters)
              </label>
              {/* List of input fields */}
              {(correctAnswer.length > 0 ? correctAnswer : ['']).map((ans, idx) => (
                <div key={idx} className="flex items-center mb-2">
                  <input
                    type="text"
                    value={ans}
                    onChange={e => {
                      const current = correctAnswer.length > 0 ? [...correctAnswer] : [''];
                      current[idx] = e.target.value;
                      setCorrectAnswer(current);
                    }}
                    maxLength={20}
                    className="flex-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 transition-all"
                    style={{
                      backgroundColor: 'var(--card-bg)',
                      color: 'var(--text-color)',
                      borderColor: 'var(--muted-color)',
                    }}
                  />
                  {correctAnswer.length > 1 && (
                    <button
                      type="button"
                      onClick={() => {
                        const updated = correctAnswer.filter((_, i) => i !== idx);
                        setCorrectAnswer(updated);
                      }}
                      className="ml-2 px-2 py-1 border rounded transition-colors duration-200"
                      style={{
                        backgroundColor: 'var(--card-bg)',
                        color: 'var(--text-color)',
                        borderColor: 'var(--muted-color)',
                      }}
                    >
                      ×
                    </button>
                  )}
                </div>
              ))}
              {/* Add new input button */}
              <button
                type="button"
                onClick={() => {
                  const current = correctAnswer.length > 0 ? [...correctAnswer] : [''];
                  setCorrectAnswer([...current, '']);
                }}
                className="px-3 py-1 border rounded transition-colors duration-200"
                style={{
                  backgroundColor: 'var(--card-bg)',
                  color: 'var(--text-color)',
                  borderColor: 'var(--muted-color)',
                }}
              >
                +
              </button>
            </div>
          )}

          {/* SUBMIT */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="px-4 py-2 rounded text-white transition-all duration-200"
              style={{ backgroundColor: 'var(--primary-color)' }}
              onMouseOver={e =>
                (e.currentTarget.style.backgroundColor = 'var(--hover-color)')
              }
              onMouseOut={e =>
                (e.currentTarget.style.backgroundColor = 'var(--primary-color)')
              }
              disabled={
                ((questionType === 'multiple_choice' ||
                  questionType === 'multiple_multiple_choice') &&
                  correctAnswer.length === 0) ||
                (questionType === 'yes_no' && correctAnswer.length === 0) ||
                (questionType === 'short_input' && !correctAnswer[0])
              }
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CorrectAnswerModal;
